export interface User {
  email: string
  displayName: string
  avatarUrl?: string
  openpaasId?: string
  color?: Record<string, string>
  objectType?: string
  kind?: 'user' | 'group'
  directoryId?: string
  login?: string
  phones?: string[]
  groups?: string[]
  memberCount?: number
  eligibleMemberCount?: number
  selectable?: boolean
  disabledReason?: string | null
}

export const userIdentity = (user: User): string => {
  if (user.kind === 'group' || user.objectType === 'group') {
    return `group:${user.directoryId || user.displayName}`.toLowerCase()
  }
  return `user:${user.email}`.toLowerCase()
}
